<template>
  <div class="postavitev-info">
    <div class="info-okvir">
      <div class="postavitev-info-icone">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="postavitev-info-tekst">
        <p class="modra-barva-info">
          Spremembe nastavitev mrežne opreme lahko trajajo nekaj minut. V primeru, da naprava ni priključena v
          omrežje, se bodo nove nastavitve konfigurirale ob vzpostavitvi.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InfoKomponentaMreznaOprema'
}
</script>
<style scoped src="../../../../../../static/css/Nastavitve/MreznaOprema/infoKomponentaMreznaOprema.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/tr069/InfoKomponentaMreznaOprema.vue